import { forwardRef } from "react"
import { mySqlToLocal } from "@helpers"
import PropTypes from "prop-types"

const SlotsHeader = forwardRef(({ 
  isFixed = false, 
  slots, 
  style={} 
}, ref) => {
  return (
    <div 
      ref={ref} 
      className={`timetable-slots__header ${isFixed ? 'timetable-slots__header--fixed' : ''}`} 
      style={style}
    >
      {slots.map((slot) => (
        <div key={slot.id} className="timetable-slots__header-slot">
          {mySqlToLocal(slot.starts_at).format("HH:mm")}
        </div>
      ))}
    </div>
  )
})

SlotsHeader.propTypes = {
  isFixed: PropTypes.bool,
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      starts_at: PropTypes.string.isRequired,
      ends_at: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    })
  ).isRequired,
  style: PropTypes.object,
}

export default SlotsHeader